const cartTools = {
    updateCart: function (dataObj, typeEdit) {
        const element = $(`.js__item_cart[data-id=${dataObj.id}]`);

        switch (typeEdit) {
            case 'remove':
                element.each(function () {
                    const wrapper = $(this).closest('.js__cart_list');
                    const typeCart = wrapper.attr('data-cart');

                    if (wrapper.find('.js__item_cart').length <= 1) {
                        switch (typeCart) {
                            case 'header':
                                $('.js__close_header').trigger('click');
                                break;

                            case 'modal':
                                $('.js__close_add_to_cart').trigger('click');
                                break;

                            case 'checkout':
                                window.location.reload(true);
                                break;
                        }
                    }
                })

                element.remove();
                break;
        }
    },

    updateTotalParam: function (totalArray) {
        $('.js__total_quantity_in_cart').empty().text(totalArray.quantity);
        $('.js__total_sum_in_cart').empty().text(totalArray.sum);
        $('.js_header__cart-count').empty().text(totalArray.quantity != 0 ? totalArray.quantity : '')
        
        if (window.getCountText) {
            getCountText(totalArray.quantity)
        }
    },

    openModalWindow: function (modal) {
        closeAllModal();
        $('body').append(modal);
    },

    updateCartHeader: function (htmlHeaderCart) {
        $('.js__header_cart').empty().append(htmlHeaderCart);
        sliderInit($('.js_modal-cart .js_goods')[0])
    },

    closeHeaderCart(button) {
        const modal = $('.js_modal-cart')
        if (modal.hasClass('active')) {
            modal.removeClass('active')
        }
    },

    updateBtnGoodPage: function (id, status) {
        const btn = $(`.js_good_page_add_cart`);

        btn.find('.in-cart, .to-cart').removeClass('active');

        switch (status) {
            case 'in_cart':
                btn.find('.in-cart').addClass('active');
                break;

            case 'to_cart':
                btn.find('.to-cart').addClass('active');
                break;
        }
    },

    addToCartSort: function (element) {
        const variant = element.attr('data-is-variants');

        const dataObj = {
            lang: lang,
            type: 'cart',
            id: element.attr('data-id'),
            quantity: 1,
            gtm: toolsGtm.gtmAddToCartSort(element, 'full'),
        };

        if (variant == 1) {
            this.getVariants(dataObj);
        } else {
            this.addToCart(dataObj);
        }
    },

    removeFromCartSort: function (element) {
        const wrapper = element.closest('.js__item_cart');

        const data = {
            'id': element.attr('data-id'),
            'lang': lang,
        }

        this.removeFromCart(data, wrapper);
    },

    updateHeaderCartCount: function (quantity, id) {
        const input = $(`.js_global__counter-input[data-id=${id}]`)
        input.val(quantity)
    },

    getVariants: function (dataObj) {
        $.post(requests.getVariants, dataObj, function (data) {
            if (data.status == 'success') {
                cartTools.openModalWindow(data.html);
            }
        });
    },

    addToCart: function (dataObj) {
        $.post(requests.addToCart, dataObj, function (data) {
            if (data.status == 'success') {
                cartTools.openModalWindow(data.html);
                cartTools.updateCartHeader(data.html_header_cart);
                cartTools.updateBtnGoodPage(dataObj.id, 'in_cart');
                cartTools.updateTotalParam(data.total);
                toolsGtm.gtmAddToCart(data.gtm_info, 'main');
            }
        });
    },

    removeFromCart: function (dataObj, wrapper) {
        $.post(requests.removeFromCart, dataObj, function (data) {
            if (data.status == 'success') {
                cartTools.updateCart(dataObj, 'remove');
                cartTools.updateBtnGoodPage(dataObj.id, 'to_cart');
                cartTools.updateTotalParam(data.total);
                wrapper.remove()
            }
        });
    },

    postUpdateCart: function (dataObj) {
        $.post(requests.updateCart, dataObj, function (data) {
            if (data.status == 'success') {
                cartTools.updateCart(dataObj, 'quantity');
                cartTools.updateTotalParam(data.total);
                cartTools.updateHeaderCartCount(dataObj.quantity, dataObj.id)
                $(`.js_cart-item__summ[data-id=${dataObj.id}]`).text(data.summ_good)

                if (dataObj.type_button == 'plus') {
                    data.gtm_info.quantity = 1;
                    toolsGtm.gtmAddToCart(data.gtm_info, 'main');
                }
            }
        });
    }
};

$(document).ready(function () {
    $(document).on('click', '.js_modal-cart__close', function () {
        cartTools.closeHeaderCart($(this))
    })

    $(document).on('click', '.js__remove_good_cart', function () {
        const btn = $(this);
        cartTools.removeFromCartSort(btn);
    });

    $(document).on('click', '.js_add__cart', function () {
        const btn = $(this);
        cartTools.addToCartSort(btn);
    });
    $(document).on('change', '.js_change_count', function () {
        const data = {
            'id': $(this).attr('data-id'),
            'quantity': $(this).val(),
            'type_button': $(this).attr('data-btn'),
        }

        cartTools.postUpdateCart(data);
    })
});